/** @format */

import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from '../loader';
import { TranslationProvider } from '@context/translation-context';

const CreditList = lazy(
  () => import(/* webpackChunkName: "credit-list" */ './cme-credit-list')
);

/**
 * CME Credits.
 */
export const cmeCredits = (): void => {
  const cmeContainer = document.querySelector('.cme-credit-container');
  if (cmeContainer) {
    const root = createRoot(cmeContainer);
    root.render(
      <Suspense fallback={<Loader />}>
        <TranslationProvider>
          <CreditList />
        </TranslationProvider>
      </Suspense>
    );
  }
};
